import { ChangeDetectionStrategy, Component, computed, input, WritableSignal } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MaterialIconComponent } from '@ps-gui/shared-core';
import { AbstractBasicSignalInput } from '../../abstract-basic-signal-input.component';

export interface Checkbox<T> {
  text: string;
  value: T;
  checked: WritableSignal<boolean>;
}

@Component({
  selector: 'shared-ui-checkbox-signal',
  imports: [MaterialIconComponent, NgTemplateOutlet],
  templateUrl: './checkbox-signal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxSignalComponent<T> extends AbstractBasicSignalInput<T> {
  readonly checkbox = input.required<Checkbox<T>>();

  readonly checked = computed(() => this.checkbox().checked());

  toggle() {
    this.checkbox().checked.set(!this.checkbox().checked());
  }
}
